import React from 'react';
import Button from './Button';
import './Home.css';

const Home = ({ instructionsClicKHandler, continueClickHandler }) => {
    function reiniciar() {
        window.location.reload();
    }

    return (
        <div className="home__container">
            <div className="home">
                <Button text="Volver a inicio" type="button-home" onClickHandler={reiniciar} />
                <Button text="Continuar partida" type="button-home" onClickHandler={continueClickHandler} />
                <Button text="Ver instrucciones" type="button-home" onClickHandler={instructionsClicKHandler} />
            </div>
        </div>
    );
};

export default Home;
